import FormatCurrency from 'components/Common/FormatCurrency'
import type { ComponentProps, ReactElement } from 'react'
import BodyText from '../Typography/BodyText'
import _PriceSummaryRow from './_PriceSummaryRow'
import TextLoadingBox from '../Typography/TextLoadingBox'

interface Props extends Utils.PropsWithDataAttributes {
  /**
   * @default default
   */
  kind?: 'default' | 'lux-plus' | 'urgency'
  /**
   * Textual content at the start.
   */
  label: string | ReactElement
  /**
   * Formatted price at the end.
   */
  discountValue?: number
  /**
   * Puts the value in a loading state.
   */
  discountValueLoading?: boolean
  discountStrikethrough?: boolean
  /**
   * @default preciseDollar
   */
  discountValueFormat?: ComponentProps<typeof FormatCurrency>['format']
}

const KINDS_BODY_TEXT_COLOURS: Record<NonNullable<Props['kind']>, ComponentProps<typeof BodyText>['colour']> = {
  default: 'success-dark',
  'lux-plus': 'lux-plus',
  urgency: 'urgency',
}

function PriceSummaryRowItemDescriptionDiscount(props: Props) {
  const {
    kind = 'default',
    label,
    discountValue,
    discountValueLoading,
    discountStrikethrough,
    discountValueFormat = 'preciseDollar',
    ...rest
  } = props

  const hidePromoAmount = discountValue == undefined || discountValue == 0

  return <_PriceSummaryRow
    {...rest}
    startSlot={<BodyText variant="medium" weight="bold" colour={KINDS_BODY_TEXT_COLOURS[kind]} lineClamp={4}>
      {label}
    </BodyText>}
    endSlot={!hidePromoAmount && <BodyText
      variant="medium"
      weight="normal"
      colour={KINDS_BODY_TEXT_COLOURS[kind]}
      wrap="no-wrap"
      strikeThrough={discountStrikethrough}
    >
      {!discountValueLoading && <FormatCurrency value={discountValue} format={discountValueFormat} />}
      {discountValueLoading && <TextLoadingBox width="8ch" />}
    </BodyText>}
  />
}

export default PriceSummaryRowItemDescriptionDiscount
